import React from 'react'
import { Modal, Button } from 'react-bootstrap'

type ConfirmProps = {
  show: boolean
  title?: string
  body: string
  confirmText?: string
  cancelText?: string
  onConfirmClick: () => void
  onCancelClick: () => void
  isLoading?: boolean
  loadingText?: string
  isDanger?: boolean
}

const Confirm: React.FC<ConfirmProps> = ({
  show,
  title,
  body,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirmClick,
  onCancelClick,
  isLoading = false,
  loadingText = 'Loading...',
  isDanger = true
}) => {
  return (
    <Modal show={show} onHide={onCancelClick} data-testid="confirmModalFC">
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body>
        <p>{body}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={onConfirmClick}
          variant={isDanger ? 'danger' : 'primary'}
          disabled={isLoading}
          data-testid="confirmModalOk"
        >
          {isLoading ? loadingText : confirmText}
        </Button>
        <Button
          onClick={onCancelClick}
          variant={isDanger ? 'secondary' : 'light'}
          disabled={isLoading}
          data-testid="confirmModalCancel"
        >
          {cancelText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Confirm
